module.exports = __webpack_public_path__ + "img/abc_logo.de041b4.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/media/abc_logo.svg
// module id = ./assets/img/media/abc_logo.svg
// module chunks = 0 9 11 12